var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".unified-checkout-picker[data-v-71524faf] {\n  min-height: 48px;\n}\n\n.unified-checkout-screen[data-v-71524faf] {\n  min-height: 320px;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "HostedCheckoutSdk",
  props: {
    jwt: {
      type: String,
      required: true
    },
    clientLibrary: {
      type: String,
      required: true
    },
    clientLibraryIntegrity: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loadError: null
    };
  },
  mounted: function mounted() {
    this.loadCybersourceScript();
  },

  methods: {
    loadCybersourceScript: function loadCybersourceScript() {
      var _this = this;

      if (!this.clientLibrary || !this.clientLibraryIntegrity || !this.jwt) {
        this.loadError = "Missing Unified Checkout initialization data.";
        return;
      }

      if (document.querySelector("script[src=\"" + this.clientLibrary + "\"]")) {
        this.launchCheckout();
        return;
      }

      var script = document.createElement("script");
      script.src = this.clientLibrary;

      script.integrity = this.clientLibraryIntegrity;
      script.crossOrigin = "anonymous";
      script.async = true;

      script.onload = function () {
        return _this.launchCheckout();
      };
      script.onerror = function () {
        _this.loadError = "Failed to load the secure checkout library.";
      };

      document.head.appendChild(script);
    },
    launchCheckout: async function launchCheckout() {
      try {
        var client = await VAS.UnifiedCheckout(this.jwt);
        var checkout = await client.createCheckout();

        var result = await checkout.mount({
          paymentSelection: "#buttonPaymentListContainer",
          paymentScreen: "#embeddedPaymentContainer"
        });

        this.$emit("payment-complete", { result: result });

        checkout.destroy();
        client.destroy();
      } catch (error) {
        console.log(error, "THIS IS ERROR");
        this.$emit("payment-error", error);
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-3"},[_c('p',{staticClass:"text-sm text-gray-500"},[_vm._v("\n    Click the button below to open the secure card entry form.\n  ")]),_vm._v(" "),_c('div',{staticClass:"unified-checkout-picker",attrs:{"id":"buttonPaymentListContainer"}}),_vm._v(" "),_c('div',{staticClass:"unified-checkout-screen",attrs:{"id":"embeddedPaymentContainer"}}),_vm._v(" "),(_vm.loadError)?_c('p',{staticClass:"text-red-500 text-sm mt-3"},[_vm._v(_vm._s(_vm.loadError))]):_vm._e()])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-71524faf"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71524faf", __vue__options__)
  } else {
    hotAPI.reload("data-v-71524faf", __vue__options__)
  }
})()}